module.exports = __webpack_public_path__ + "static/media/upv_data.586ea76b.png";